import { render, staticRenderFns } from "./EmailTemplatePage.vue?vue&type=template&id=cf1a2faa&"
import script from "./EmailTemplatePage.vue?vue&type=script&lang=js&"
export * from "./EmailTemplatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports